import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from '@/contexts/auth'
export function AuthGuard ( props ) {
  const { component:Componnet, path } = props
  
  return (
    <AuthConsumer>
      {( { authenticated, logout } ) => (
        <Route path={path} render={props => authenticated ? (
          <Componnet {...props} location={props.location} />
        ) : <Redirect to="/"/> } /> 
      )}
    </AuthConsumer>
  )
}


// WEBPACK FOOTER //
// ./src/components/auth/AuthGuard.js